import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";

const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getLeadsReport(
  oauthTokenHeader: string,
  data: {
    website_shared_uid: string[];
    date_from: string;
    date_to: string;
    page: number;
    page_size: number;
    search?: string;
    report_status?: string;
    brand_uid?: string[];
    qualified_by_brand?: boolean;
    lead_scoring_min?: number;
    has_duplicate_ip?: boolean;
  },
) {
  return fetchWrapper.post(
    `${apiUrl}/partners/brand_leads_report/`,
    data,
    oauthTokenHeader,
  );
}

function reportLeads(oauthTokenHeader: string, data: { lead_ids: number[] }) {
  return fetchWrapper.post(
    `${apiUrl}/partners/brand_leads/report/`,
    data,
    oauthTokenHeader,
  );
}

// Rejects Pending leads — a one-way transition, distinct from report/.
function rejectLeads(oauthTokenHeader: string, data: { lead_ids: number[] }) {
  return fetchWrapper.patch(
    `${apiUrl}/partners/brand_leads/status/`,
    { lead_ids: data.lead_ids, report_status: "Rejected" },
    oauthTokenHeader,
  );
}

// Brand Match diagnostic BQL query — checks a lead's answers against every
// brand's requirements. Query ID is fixed per the Brand Match spec.
const BRAND_MATCH_QUERY_ID = "5673627085176832";

function runBrandMatchQuery(
  oauthTokenHeader: string,
  data: { websiteSharedUid: string; leadId: string },
) {
  const searchParams = new URLSearchParams();
  searchParams.append("type", "site");
  searchParams.append("website_shared_uid", data.websiteSharedUid);
  searchParams.append("id", data.leadId);

  const fullUrl = `${apiUrl}/biz_layer_query/run/${BRAND_MATCH_QUERY_ID}/?${searchParams.toString()}`;

  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}

function reassignAndReportLead(
  oauthTokenHeader: string,
  data: { lead_id: number; brand_uid: string },
) {
  return fetchWrapper.post(
    `${apiUrl}/partners/leads/reassign_and_report/`,
    data,
    oauthTokenHeader,
  );
}

export const leadsManagementService = {
  getLeadsReport,
  reportLeads,
  rejectLeads,
  runBrandMatchQuery,
  reassignAndReportLead,
};
